<div class="ibox">
    <div class="ibox-content carrierList" *ngFor="let entry of bluechatFindByDeliveryNumberLoad">
        <h4>{{entry.carrierName}}</h4>
        <ul>
            <li *ngFor="let deliveryNumber of entry.deliveryNumbers"><small>{{deliveryNumber}}</small></li>
        </ul>
    </div>
</div>
